import { Controller } from "@hotwired/stimulus"

// Replaces ISO country codes in a <select> with names localized to the page
// language and re-sorts the options alphabetically. The server only knows
// codes; the CLDR country names live in the browser's Intl.DisplayNames.
export default class extends Controller {
  connect() {
    const locale = document.documentElement.lang || "en"
    let displayNames
    try {
      displayNames = new Intl.DisplayNames([locale], { type: "region" })
    } catch {
      return
    }

    const selected = this.element.value
    const options = Array.from(this.element.options).filter((option) => option.value)
    for (const option of options) {
      option.textContent = displayNames.of(option.value) || option.value
    }
    options.sort((a, b) => a.textContent.localeCompare(b.textContent, locale))
    this.element.append(...options)
    this.element.value = selected
  }
}
